import { check } from '../../index';
var arrayLike = function arrayLike(arrayLikeObject) {
  return check.integer(arrayLikeObject.length);
};
export { arrayLike };